/**
 * @generated SignedSource<<301b9d6a31601dbc9e6ceb4950e617c2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceCardExampleProjects_productizedService$data = {
  readonly portfolioProjects: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardExampleProject_portfolioProject">;
      };
    }>;
  };
  readonly " $fragmentType": "ProductizedServiceCardExampleProjects_productizedService";
};
export type ProductizedServiceCardExampleProjects_productizedService$key = {
  readonly " $data"?: ProductizedServiceCardExampleProjects_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceCardExampleProjects_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceCardExampleProjects_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePortfolioProjectConnection",
      "kind": "LinkedField",
      "name": "portfolioProjects",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProductizedServicePortfolioProjectEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioProject",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "ProductizedServiceCardExampleProject_portfolioProject"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "1e81eced7a816554439f22a96607db1f";

export default node;
